module.exports = __webpack_public_path__ + "img/space-warper.0055266b.png";